export enum AppActionContext {
    ORG = 'org',
    DOMAIN = 'domain',
}
